import HTTP from "@/_helpers/http";
import { USERLIVETRADES__API } from "@/_helpers/urls";
import { USERLIVETRADES__MUTATIONS } from "../mutation-types";
import { USERLIVETRADES__ACTIONS } from "../action-types";

// State
const state = {
    trades: [],
    totalProfit: 0,
    totalVolume: 0,
    totalEquity: 0,
    isLoading: false,
    lastUpdate: null,
    currentFilters: null
};

//Getters
const getters = {
    hasActiveFilters: (state) => {
        return state.currentFilters !== null;
    }
};

//Mutations
const mutations = {
    [USERLIVETRADES__MUTATIONS.USERLIVETRADES](state, data) {
        state.trades = data?.liveTrades?.data;
        state.totalProfit = data.totalProfit;
        state.totalVolume = data.totalVolume;
        state.totalEquity = data.totalEquity;
    },
    SET_LOADING(state, data) {
        state.isLoading = data;
    },
    SET_CURRENT_FILTERS(state, filters) {
        state.currentFilters = filters;
    }
};

// Actions
const actions = {
    async [USERLIVETRADES__ACTIONS.USERLIVETRADES]({ commit, state }, parameter) {
        try {
            // Don't set loading for background updates
            const isBackgroundUpdate = !parameter;
            if (!isBackgroundUpdate) {
                commit("SET_LOADING", true);
                commit("SET_CURRENT_FILTERS", parameter);
            }

            // Use current filters if no parameters provided (background update)
            const params = parameter || state.currentFilters || {};

            const idParam = params?.clientId != null ? `clientId=${params.clientId}` : "";
            const pageParam = params?.page != null ? `page=${params.page}` : "";

            const itemsPerPageParam =
                params?.itemsPerPage != null
                    ? `itemsPerPage=${params.itemsPerPage}`
                    : "";

            const tradingAccTypeIdParam =
                params?.trading_account_type_id != null
                    ? `trading_account_type_id=${params.trading_account_type_id}`
                    : "";

            const parameterString = [
                idParam,
                pageParam,
                itemsPerPageParam,
                tradingAccTypeIdParam
            ]
                .filter((param) => param !== "")
                .join("&");

            const response = await HTTP().get(
                USERLIVETRADES__API.USERLIVETRADES +
                (parameterString !== "" ? `?${parameterString}` : "")
            );

            commit(USERLIVETRADES__MUTATIONS.USERLIVETRADES, response.data);
            commit("SET_LOADING", false);
            if (!isBackgroundUpdate) {
                commit("SET_LOADING", false);
            }
        } catch (error) {
            console.error('Error fetching closed trades:', error);
            if (!parameter) {
                commit("SET_LOADING", false);
            }
        }
    },
    async fetchUpdates({ dispatch, state, getters }) {
        try {
            if (getters.hasActiveFilters) {
                return dispatch(USERLIVETRADES__ACTIONS.USERLIVETRADES);
            }

            return dispatch(USERLIVETRADES__ACTIONS.USERLIVETRADES, null);
        } catch (error) {
            console.error('Error in background update:', error);
        }
    },
};

export default {
    namespaced: true,
    strict: process.env.NODE_ENV !== "production",
    state,
    getters,
    mutations,
    actions,
};
